// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width: 48rem){\n.share-wrapper[data-v-1034d1da]{\n    display:-webkit-box;\n    display:-ms-flexbox;\n    display:flex;\n    -webkit-box-align:center;\n        -ms-flex-align:center;\n            align-items:center;\n    -webkit-box-pack:end;\n        -ms-flex-pack:end;\n            justify-content:flex-end\n}\n}\n@media (max-width: 47.9375rem){\nspan[data-v-1034d1da]:first-child{\n    margin-bottom:1rem;\n    text-align:center\n}\n}", ""]);
// Exports
module.exports = exports;
